import {
  Button,
  Modal,
  DatePicker,
  Flex,
  Form,
  Typography,
  message,
  notification,
  Input,
  Row,
  Col,
  Checkbox,
} from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import './Seat/seat-map.css';
import SeatIcon from './Seat/SeatIcon';
import _, { orderBy } from 'lodash';
import seatMapApi from '../../api/seat-map';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import frFR from 'antd/es/date-picker/locale/fr_FR';
import { useDispatch, useSelector } from 'react-redux';
import useTime from '../../hooks/useTime';
import SteeringWheelIcon from './Seat/SteeringWheelIcon';
import Pusher from 'pusher-js';
import { PUSHER_APP_KEY } from '../../utils/constant';
import { SmileOutlined } from '@ant-design/icons';
import {
  setNotifiSeatLockedDeparture,
  setNotifiSeatLockedReturn,
  updateSegmentDeparture,
  updateSegmentReturn,
} from '../../redux/actions/CreateBookingAction';
import routesApi from '../../api/route';

const { Text } = Typography;
const { RangePicker } = DatePicker;

const PreviewSeatMap = (props) => {
  const {
    open,
    onClose,
    currentData,
    routesData,
    isModal,
    createBookingData,
    handleSelectSeat,
    selectedSeat,
    disabledSeat,
    setDisabledSeat,
    handleDisabledSeat,
    setIsUpdateSeat,
    busySeat,
    maxSeat,
    isUpdateSeat,
    bookingDetail,
    bookingStatisticRouteData,
    loadingSeatMap,
    setLoadingSeatMap,
  } = props;
  const [seatData, setSeatData] = useState({ block_type: [], number: [] });
  const [rows, setRows] = useState(0);
  const [columns, setColumns] = useState(0);
  const [lockSeat, setLockSeat] = useState([]);
  const [booked, setBooked] = useState([]);
  const [disabled, setDisabled] = useState([]);
  const [dateString, setDateString] = useState();
  const [route, setRoute] = useState(null);
  const [maxSeatNumber, setMaxSeatNumber] = useState(null);
  const [reload, setReload] = useState(false);
  const [selectedWeekdays, setSelectedWeekdays] = useState([
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
  ]);
  const searchValues = useSelector(
    (state) => state.createBookings.searchValues,
  );
  const [loadingCreateDisabled, setLoadingCreateDisabled] = useState(false);
  const [loadingEnableSeat, setLoadingEnableSeat] = useState(false);

  const dispatch = useDispatch();

  const [filter, setFilter] = useState({
    date: dayjs(new Date()).format('YYYY-MM-DD'),
  });
  const [filterDisabledSeat, setFilterDisabledSeat] = useState({
    depart_date: dayjs(new Date()).format('YYYY-MM-DD'),
  });
  const [api, contextHolder] = notification.useNotification();
  const Context = React.createContext({
    name: 'Default',
  });

  const { formatAsISOString } = useTime();

  const showNotification = (data, placement) => {
    api.info({
      message: `${bookingDetail?.start_stop?.title} - ${bookingDetail?.end_stop?.title} `,
      description: (
        <Context.Consumer>
          {({ name }) => `Seat number ${data} has been taken`}
        </Context.Consumer>
      ),
      duration: 8,
      placement: placement,
      icon: <SmileOutlined style={{ color: '#108ee9' }} />,
      stack: false,
    });
  };

  const { convertToAnyTimezone } = useTime();

  const [form] = Form.useForm();
  const [formDisabled] = Form.useForm();

  const onChange = (date, dateString) => {
    setDateString(dateString);
  };

  const isMounted = useRef(false);
  const fetch = useCallback(async () => {
    if (!routesData && !createBookingData && !bookingStatisticRouteData) return;

    let filterDate = {};
    if (searchValues.date) {
      filterDate.date = convertToAnyTimezone(searchValues.date).format(
        'YYYY-MM-DD',
      );
    }
    if (routesData) {
      setRoute(routesData?.id);
      const dateSeatMap = await seatMapApi.getSeatLock(routesData?.id, filter);
      const getDisabledSeat = await routesApi.getDisabledSeatById({
        ...filterDisabledSeat,
        routeId: routesData?.id,
      });

      setLockSeat(dateSeatMap.locked);
      setBooked(dateSeatMap.booked);
      if (getDisabledSeat) {
        setDisabled(getDisabledSeat.disabled);
      }
      setLoadingSeatMap(false);
      setReload(false);
    } else if (isUpdateSeat || busySeat) {
      setLockSeat(busySeat?.locked);
      setBooked(busySeat?.booked);
      setDisabled(busySeat?.disabled);
    } else if (bookingStatisticRouteData) {
      const dateSeatMap = await seatMapApi.getBusySeatRoute(
        bookingStatisticRouteData?.route_id,
        {
          date: dayjs(new Date(bookingStatisticRouteData?.date)).format(
            'YYYY-MM-DD',
          ),
        },
      );
      setBooked(dateSeatMap?.booked);
      setDisabled(dateSeatMap?.disabled);
      setLockSeat(dateSeatMap?.locked);
    }
  }, [routesData, filter, isUpdateSeat, bookingStatisticRouteData, reload]);

  useEffect(() => {
    isMounted.current = true;

    if (currentData) {
      setRows(JSON.parse(currentData.block_layout).row);
      setColumns(JSON.parse(currentData.block_layout).column);
      setSeatData({
        block_type: JSON.parse(currentData.block_layout).block_type,
        number: JSON.parse(currentData.block_layout).seatnumber,
      });
      // setMaxSeatNumber(
      //   Math.max(
      //     ...{
      //       block_type: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
      //         .block_type,
      //       number: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
      //         .seatnumber,
      //     }.number.map(Number)
      //   )
      // );
    } else if (routesData) {
      setRows(JSON.parse(routesData?.seatmap?.seatmap?.block_layout).row);
      setColumns(JSON.parse(routesData?.seatmap?.seatmap?.block_layout).column);
      setSeatData({
        block_type: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
          .block_type,
        number: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
          .seatnumber,
      });
      setMaxSeatNumber(
        Math.max(
          ...{
            block_type: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
              .block_type,
            number: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
              .seatnumber,
          }.number.map(Number),
        ),
      );
    } else if (createBookingData) {
      setRows(JSON.parse(createBookingData.block_layout).row);
      setColumns(JSON.parse(createBookingData.block_layout).column);
      setSeatData({
        block_type: JSON.parse(createBookingData.block_layout).block_type,
        number: JSON.parse(createBookingData.block_layout).seatnumber,
      });
      // setMaxSeatNumber(
      //   Math.max(
      //     ...{
      //       block_type: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
      //         .block_type,
      //       number: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
      //         .seatnumber,
      //     }.number.map(Number)
      //   )
      // );
    } else if (bookingStatisticRouteData) {
      setRows(JSON.parse(bookingStatisticRouteData?.seatmap).row);
      setColumns(JSON.parse(bookingStatisticRouteData?.seatmap).column);
      setSeatData({
        block_type: JSON.parse(bookingStatisticRouteData?.seatmap).block_type,
        number: JSON.parse(bookingStatisticRouteData?.seatmap).seatnumber,
      });
      // setMaxSeatNumber(
      //   Math.max(
      //     ...{
      //       block_type: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
      //         .block_type,
      //       number: JSON.parse(routesData?.seatmap?.seatmap?.block_layout)
      //         .seatnumber,
      //     }.number.map(Number)
      //   )
      // );
    }

    fetch();
    return () => {
      isMounted.current = false;
    };
  }, [currentData, filter, reload]);

  useEffect(() => {
    Pusher.logToConsole = true;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
    });
    let channelReturn;

    const channel = pusher.subscribe(
      `lockseat_${bookingDetail?.id}_${convertToAnyTimezone(
        searchValues?.date,
      ).format('YYYY-MM-DD')}`,
    );

    channel.bind('lock_seat', async function (data) {
      let filter = {};
      if (searchValues.date) {
        filter.date = convertToAnyTimezone(searchValues.date).format(
          'YYYY-MM-DD',
        );
      }
      const newFilter = filter || {
        date: convertToAnyTimezone(new Date()).format('YYYY-MM-DD'),
      };

      const getRealTimeSeat = await seatMapApi.getSeatLock(
        bookingDetail?.id,
        newFilter,
      );
      if (getRealTimeSeat) {
        setLockSeat(getRealTimeSeat?.locked);
        setBooked(getRealTimeSeat?.booked);
      }
      showNotification(data.seat, 'topRight');
      const listSeatLocked = data.seat.split(',');
      dispatch(
        setNotifiSeatLockedDeparture({
          seatRealTimeLocked: listSeatLocked,
        }),
      );
      setIsUpdateSeat(true);
    });

    if (searchValues?.roundtrip) {
      channelReturn = pusher.subscribe(
        `lockseat_${bookingDetail?.id}_${convertToAnyTimezone(
          searchValues?.return_date,
        ).format('YYYY-MM-DD')}`,
      );

      channelReturn.bind('lock_seat', async function (data) {
        let filter = {};
        if (searchValues.return_date) {
          filter.date = convertToAnyTimezone(searchValues.return_date).format(
            'YYYY-MM-DD',
          );
        }
        const newFilter = filter || {
          date: convertToAnyTimezone(new Date()).format('YYYY-MM-DD'),
        };

        const getRealTimeSeat = await seatMapApi.getSeatLock(
          bookingDetail?.id,
          newFilter,
        );
        if (getRealTimeSeat) {
          setLockSeat(getRealTimeSeat?.locked);
          setBooked(getRealTimeSeat?.booked);
        }
        showNotification(data.seat, 'topLeft');
        const listSeatLocked = data.seat.split(',');
        dispatch(
          setNotifiSeatLockedReturn({
            returnSeatRealTimeLocked: listSeatLocked,
          }),
        );
        setIsUpdateSeat(true);
      });
    }

    return () => {
      channel.unbind('lock_seat');
      if (searchValues?.roundtrip) {
        channelReturn.unbind('lock_seat');
      }
      pusher.disconnect();
    };
  }, [bookingDetail, searchValues]);

  useEffect(() => {
    if (routesData) {
      formDisabled &&
        formDisabled.setFieldsValue({
          seat: disabledSeat.join(', '),
        });
    }
    return;
  }, [disabledSeat, formDisabled]);

  const getSeatStyles = (
    seatNumber,
    selectedSeat,
    locked,
    booked,
    disabled,
    selectedDisabled,
  ) => {
    const isSelected = _.includes(selectedSeat, seatNumber);
    const isLocked = _.includes(locked, seatNumber);
    const isBooked = _.includes(booked, seatNumber);
    const isDisabled = _.includes(disabled, seatNumber);
    const isSelectedDisabled =
      _.includes(selectedDisabled, seatNumber) &&
      !_.includes(disabled, seatNumber);
    let fill = '#FFF';
    let stroke = '#B8B8B8';
    let textColor = '#000';
    if (isSelected) {
      fill = '#04bc8c';
      stroke = '#FFF';
      textColor = '#FFF';
    } else if (isBooked) {
      fill = '#fc346a';
      stroke = '#FFF';
      textColor = '#FFF';
    } else if (isLocked) {
      fill = '#000';
      stroke = '#FFF';
      textColor = '#FFF';
    } else if (isDisabled) {
      fill = '#a0a0a0';
      stroke = '#FFF';
      textColor = '#FFF';
    } else if (isSelectedDisabled) {
      fill = '#4e5252';
      stroke = '#FFF';
      textColor = '#FFF';
    }

    return { fill, stroke, textColor };
  };

  const handleSubmit = () => {
    setFilterDisabledSeat({
      depart_date: dayjs(dateString).format('YYYY-MM-DD'),
    });

    setFilter({
      date: dayjs(dateString).format('YYYY-MM-DD'),
    });

    setLoadingSeatMap(true);
  };

  const handleCreateDisabledSeat = (data) => {
    formDisabled
      .validateFields()
      .then(async (values) => {
        setLoadingCreateDisabled(true);
        const data = { ...values };
        let from_date = null;
        let to_date = null;

        if (values?.depart_date) {
          from_date = JSON.stringify(formatAsISOString(values?.depart_date[0]));
          to_date = JSON.stringify(formatAsISOString(values?.depart_date[1]));
        }
        data.route_id = route;
        data.from_date = from_date.substring(1, 11);
        data.to_date = to_date.substring(1, 11);
        data.weekdays = selectedWeekdays;
        delete data.depart_date;
        const res = await routesApi.createDisabledSeat(data);

        if (res) {
          !res.code ? message.success(res.message) : message.info(res.message);
          setLoadingCreateDisabled(false);
          setDisabledSeat([]);
          setReload(true);
          // setLoadingSeatMap(true);
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const handleChangeWeekDay = (checkedValues) => {
    setSelectedWeekdays(checkedValues);
  };

  const handleEnableSeat = (data) => {
    formDisabled
      .validateFields()
      .then(async (values) => {
        setLoadingEnableSeat(true);
        const data = { ...values };
        let from_date = null;
        let to_date = null;

        if (values?.depart_date) {
          from_date = JSON.stringify(formatAsISOString(values?.depart_date[0]));
          to_date = JSON.stringify(formatAsISOString(values?.depart_date[1]));
        }
        data.route_id = route;
        data.from_date = from_date.substring(1, 11);
        data.to_date = to_date.substring(1, 11);
        data.weekdays = selectedWeekdays;

        delete data.depart_date;
        const res = await routesApi.enableSeat(data);
        if (res) {
          !res.code ? message.success(res.message) : message.info(res.message);

          setLoadingEnableSeat(false);
          setDisabledSeat([]);
          setReload(true);
          // setLoadingSeatMap(true);
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <>
      {isModal ? (
        <Modal
          title=""
          open={open}
          onCancel={onClose}
          onOk={onClose}
          width={'90%'}
          footer={[
            <Button key="ok" onClick={onClose} type="primary">
              <IntlMessage id="global.ok" />
            </Button>,
          ]}>
          {routesData ? (
            <Form form={form} onFinish={handleSubmit}>
              <Flex gap={4} justify="center" style={{ width: '100%' }}>
                <Form.Item>
                  <DatePicker
                    onChange={onChange}
                    style={{ width: '200px' }}
                    defaultValue={dayjs()}
                    format={'DD-MM-YYYY'}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    htmlType="submit"
                    type="primary"
                    loading={loadingSeatMap}>
                    <IntlMessage id="global.show_seat_map" />
                  </Button>
                </Form.Item>
              </Flex>
            </Form>
          ) : null}

          <Flex>
            <div
              className="data-table"
              style={{
                gridTemplateRows: `repeat(${rows}, 1fr)`,
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                width: '100%',
                marginRight: 12,
              }}
              dir="rtl">
              {seatData && seatData.block_type
                ? seatData.block_type.map((row, index) => {
                    return (
                      <div className="row" key={index} dir="rtl">
                        {row === 'hidden' ? (
                          <div style={{ display: 'none' }}></div>
                        ) : (
                          <SeatIcon
                            seat_number={seatData.number[index]}
                            {...getSeatStyles(
                              seatData.number[index],
                              selectedSeat,
                              lockSeat,
                              booked,
                              disabled,
                              disabledSeat,
                            )}
                            disabled={disabled}
                            onClick={
                              disabledSeat
                                ? () =>
                                    handleDisabledSeat(seatData.number[index])
                                : null
                            }
                          />
                        )}
                      </div>
                    );
                  })
                : null}
            </div>
            <div
              className="steering_wheel_icon"
              style={{ paddingLeft: 8, marginTop: 8 }}>
              <SteeringWheelIcon />
            </div>
          </Flex>

          {routesData ? (
            <Flex justify="center" gap={12} style={{ marginTop: 20 }}>
              <div
                style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <div
                  className="box-seat"
                  style={{ background: '#a0a0a0', borderRadius: 2 }}></div>
                <Text>
                  <IntlMessage id="global.disabled" />
                </Text>
              </div>
              <div
                style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <div
                  className="box-seat"
                  style={{ background: '#fc346a', borderRadius: 2 }}></div>
                <Text>
                  <IntlMessage id="global.taken" />
                </Text>
              </div>
              <div
                style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <div
                  className="box-seat"
                  style={{ background: '#000', borderRadius: 2 }}></div>
                <Text>
                  <IntlMessage id="global.locked" />
                </Text>
              </div>
              <div
                style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <div
                  className="box-seat"
                  style={{
                    background: '#FFF',
                    border: '1px solid #000',
                    borderRadius: 2,
                  }}></div>
                <Text>
                  <IntlMessage id="global.free" />
                </Text>
              </div>
            </Flex>
          ) : null}

          {bookingStatisticRouteData ? (
            <Flex justify="center" gap={12} style={{ marginTop: 20 }}>
              <div
                style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <div
                  className="box-seat"
                  style={{ background: '#a0a0a0', borderRadius: 2 }}></div>
                <Text>
                  <IntlMessage id="global.disabled" />
                </Text>
              </div>
              <div
                style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <div
                  className="box-seat"
                  style={{ background: '#fc346a', borderRadius: 2 }}></div>
                <Text>
                  <IntlMessage id="global.taken" />
                </Text>
              </div>
              <div
                style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <div
                  className="box-seat"
                  style={{ background: '#000', borderRadius: 2 }}></div>
                <Text>
                  <IntlMessage id="global.locked" />
                </Text>
              </div>
            </Flex>
          ) : null}
          {routesData ? (
            <div className="border_action">
              <Form
                labelCol={{
                  span: 12,
                }}
                wrapperCol={{
                  span: 12,
                }}
                labelAlign="left"
                form={formDisabled}
                name="control-hooks"
                style={{ width: 900, marginTop: 20 }}
                onFinish={handleCreateDisabledSeat}>
                <>
                  <Form.Item
                    name="depart_date"
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfield" />,
                      },
                    ]}>
                    <RangePicker
                      placeholder={['Date', 'Date']}
                      format={'DD-MM-YYYY'}
                      // onChange={handleRangeChange}
                    />
                  </Form.Item>
                  {routesData ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingBottom: 5,
                      }}>
                      <Text style={{ flex: 2 }}>
                        {<IntlMessage id="global.weekdays" />}
                      </Text>
                      <Checkbox.Group
                        style={{ width: '100%', flex: 9 }}
                        value={selectedWeekdays}
                        onChange={handleChangeWeekDay}>
                        <Row>
                          <Col span={3}>
                            <Checkbox value="1" checked>
                              Lundi
                            </Checkbox>
                          </Col>
                          <Col span={3}>
                            <Checkbox value="2" defaultChecked>
                              Mardi
                            </Checkbox>
                          </Col>
                          <Col span={3}>
                            <Checkbox value="3">Mercredi</Checkbox>
                          </Col>
                          <Col span={3}>
                            <Checkbox value="4">Jeudi</Checkbox>
                          </Col>
                          <Col span={3}>
                            <Checkbox value="5">Vendredi</Checkbox>
                          </Col>
                          <Col span={3}>
                            <Checkbox value="6">Samedi</Checkbox>
                          </Col>
                          <Col span={3}>
                            <Checkbox value="0">Dimanche</Checkbox>
                          </Col>
                        </Row>
                      </Checkbox.Group>
                    </div>
                  ) : null}
                  <Form.Item
                    name="seat"
                    label={<IntlMessage id="global.seat" />}
                    labelCol={4}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) {
                            return Promise.resolve();
                          }
                          // check number legit
                          const seatNumbers = value
                            .split(', ')
                            .map((num) => num.trim());
                          let errorMessages;
                          // const hasInvalidNumber = seatNumbers.some(
                          //   (num) => isNaN(num) || Number(num) > sumSeat
                          // );

                          seatNumbers.forEach((num) => {
                            switch (true) {
                              case isNaN(num):
                                errorMessages =
                                  'Veuillez saisir des numéros de sièges valides, ex: 36,40,41';
                                break;

                              case num > maxSeatNumber:
                                errorMessages = `Le numéro de siège ${num} dépasse le maximum autorisé (${maxSeatNumber}).`;
                                break;
                              default:
                                break;
                            }
                          });
                          if (errorMessages) {
                            return Promise.reject(new Error(errorMessages));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}>
                    <Input
                      placeholder="Veuillez saisir ou sélectionner les sièges à bloquer (ex: 36,40,41)"
                      onChange={(e) => {
                        const value = e.target.value;
                        setDisabledSeat(
                          value
                            .split(', ')
                            .map((num) => num.trim())
                            .filter((num, index) => index !== 0 || num !== ''),
                        );
                      }}
                    />
                  </Form.Item>
                  <Flex gap={12}>
                    <Form.Item>
                      <Button
                        style={{ width: 120 }}
                        htmlType="submit"
                        loading={loadingCreateDisabled}>
                        <IntlMessage id="global.disabled_seat" />
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        style={{ width: 120 }}
                        loading={loadingEnableSeat}
                        onClick={handleEnableSeat}>
                        <IntlMessage id="global.enable_seat" />
                      </Button>
                    </Form.Item>
                  </Flex>
                </>

                {/* <Flex vertical gap={12}>
                <RangePicker
                  placeholder={["From date", "To date"]}
                  format={"DD-MM-YYYY"}
                  // onChange={handleRangeChange}
                />
                <Text>Seat: {disabledSeat.join(", ")}</Text>
                <Button style={{ width: 120 }}>
                  <IntlMessage id="global.disabled_seat" />
                </Button>
              </Flex> */}
              </Form>
            </div>
          ) : null}
        </Modal>
      ) : (
        <>
          <Flex justify="center" gap={12} style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              <div
                className="box-seat"
                style={{ background: '#04bc8c', borderRadius: 2 }}></div>
              <Text>
                <IntlMessage id="global.chosen" />
              </Text>
            </div>
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              <div
                className="box-seat"
                style={{ background: '#a0a0a0', borderRadius: 2 }}></div>
              <Text>
                <IntlMessage id="global.disabled" />
              </Text>
            </div>
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              <div
                className="box-seat"
                style={{ background: '#fc346a', borderRadius: 2 }}></div>
              <Text>
                <IntlMessage id="global.taken" />
              </Text>
            </div>
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              <div
                className="box-seat"
                style={{ background: '#000', borderRadius: 2 }}></div>
              <Text>
                <IntlMessage id="global.locked" />
              </Text>
            </div>
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              <div
                className="box-seat"
                style={{
                  background: '#FFF',
                  border: '1px solid #000',
                  borderRadius: 2,
                }}></div>
              <Text>
                <IntlMessage id="global.free" />
              </Text>
            </div>
          </Flex>

          <Flex gap={12} style={{ width: '100%' }}>
            <div
              className="data-table"
              style={{
                gridTemplateRows: `repeat(${rows}, 1fr)`,
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gap: 0,
                marginRight: '6%',
                width: '100%',
              }}
              dir="rtl">
              {contextHolder}
              {seatData && seatData.block_type
                ? seatData.block_type.map((row, index) => {
                    return (
                      <div className="row" key={index} dir="rtl">
                        {row === 'hidden' ? (
                          <div style={{ display: 'none' }}></div>
                        ) : (
                          <SeatIcon
                            width={40}
                            height={40}
                            maxSeat={maxSeat}
                            selectedSeat={selectedSeat}
                            disabledSeat={disabled}
                            onClick={() =>
                              handleSelectSeat(seatData.number[index])
                            }
                            disabled={disabled}
                            seat_number={seatData.number[index]}
                            {...getSeatStyles(
                              seatData.number[index],
                              selectedSeat,
                              lockSeat,
                              booked,
                              disabled,
                              disabledSeat,
                            )}
                          />
                        )}
                      </div>
                    );
                  })
                : null}
            </div>
            <div className="steering_wheel_icon">
              <SteeringWheelIcon />
            </div>
          </Flex>
        </>
      )}
    </>
  );
};

export default PreviewSeatMap;
